import { rgba } from "polished";
import * as React from "react";
import styled, { css } from "styled-components/";

const Item = styled.li`
  flex: 1;
`;

export const TabLink = styled.a<IStyleProps>`
  display: block;
  margin: 0.2rem;
  padding: 0.7rem ${({ theme }) => theme.space[2]};
  border-radius: 2px;
  background-color: transparent;
  color: inherit;
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  text-align: center;
  text-decoration: none;
  transition: all 0.2s;

  ${(props) =>
    props.selected &&
    css`
      background-color: white;
      box-shadow:
        0 3px 4px 0 ${rgba("black", 0.08)},
        0 3px 3px -2px ${rgba("black", 0.08)},
        0 1px 8px 0 ${rgba("black", 0.16)};
      border-radius: ${({ theme }) => theme.radii[1]};
    `}
`;

interface IStyleProps {
  selected: boolean;
}

interface IProps {
  key: number;
  index: number;
  label: React.ReactNode;
  link: string;
  onClick: (index: number) => void;
}

type Props = IStyleProps & IProps;

const Tab = ({ index, label, link, onClick, selected }: Props) => {
  const handleOnClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onClick(index);
  };

  return (
    <Item>
      <TabLink href={`#${link}`} onClick={handleOnClick} selected={selected}>
        {label}
      </TabLink>
    </Item>
  );
};

export default Tab;
